import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Tooltip } from 'antd';

/**
 * Component to conditionally render content only for admin users
 * Can also disable interactive elements for non-admin users
 */
const AdminOnly = ({ children, hideForUser = true, showTooltip = false, tooltipText = "Admin access required" }) => {
  const { isAdmin } = useAuth();

  // If user is admin, always show
  if (isAdmin()) {
    return <>{children}</>;
  }

  // If hideForUser is true, don't render anything for non-admin
  if (hideForUser) {
    return null;
  }

  // Otherwise, show disabled version with optional tooltip
  if (showTooltip) {
    return (
      <Tooltip title={tooltipText}>
        <span style={{ cursor: 'not-allowed', opacity: 0.5 }}>
          {React.cloneElement(children, { disabled: true })}
        </span>
      </Tooltip>
    );
  }

  // Just disable without tooltip
  return React.cloneElement(children, { disabled: true });
};

export default AdminOnly;
